import { render, staticRenderFns } from "./type91.vue?vue&type=template&id=3fb41ecf&scoped=true"
import script from "./type91.vue?vue&type=script&lang=js"
export * from "./type91.vue?vue&type=script&lang=js"
import style0 from "./type91.vue?vue&type=style&index=0&id=3fb41ecf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb41ecf",
  null
  
)

export default component.exports